import InfoTooltip from "./InfoTooltip";

const SORT_ICON = {
  asc: "▲",
  desc: "▼",
};

export default function SortableTh({
  label,
  sortKey,
  sortState,
  onSort,
  tooltip,
  align = "left",
  className = "",
  buttonClassName = "",
  contentClassName = "",
  tooltipLabel,
}) {
  const isActive = Boolean(sortKey && sortState?.key === sortKey);
  const sortDir = isActive ? sortState?.dir : null;
  const ariaSort = isActive
    ? sortDir === "asc"
      ? "ascending"
      : "descending"
    : "none";
  const alignClass =
    align === "right"
      ? "text-right justify-end"
      : align === "center"
      ? "text-center justify-center"
      : "text-left justify-start";
  const content = (
    <span className={`inline-flex items-center gap-1 ${contentClassName}`}>
      <span>{label}</span>
      {isActive && (
        <span className="text-[10px] text-slate-500">{SORT_ICON[sortDir] || ""}</span>
      )}
    </span>
  );

  return (
    <th className={className} aria-sort={ariaSort}>
      <div className={`flex items-center gap-1.5 ${alignClass}`}>
        {sortKey ? (
          <button
            type="button"
            onClick={() => onSort?.(sortKey)}
            className={`inline-flex items-center gap-1 font-semibold text-slate-600 hover:text-slate-900 ${buttonClassName}`}
          >
            {content}
          </button>
        ) : (
          <span className="font-semibold text-slate-600">{content}</span>
        )}
        {tooltip ? <InfoTooltip text={tooltip} label={tooltipLabel || label} /> : null}
      </div>
    </th>
  );
}
